// Which competitions a beneficiary sees (namat#33). A finished competition
// stays, read-only, so they can review the ranking and their own tally
// (AlMamoon, 2026-08-11), for ENDED_VISIBLE_DAYS after it ends.
export const ENDED_VISIBLE_DAYS = 90;
const DAY_MS = 24 * 60 * 60 * 1000;

interface Dated {
  startDate: Date;
  endDate: Date;
  isPublished?: boolean;
}

export type BeneficiaryCompetition<T> = T & { hasEnded: boolean };

export function beneficiaryCompetitions<T extends Dated>(list: T[], now: Date): BeneficiaryCompetition<T>[] {
  const oldestEnd = now.getTime() - ENDED_VISIBLE_DAYS * DAY_MS;
  return list
    // `!== false`: competitions created before isPublished existed have no field.
    .filter((c) => c.isPublished !== false && c.startDate <= now && c.endDate.getTime() >= oldestEnd)
    .map((c) => ({ ...c, hasEnded: now > c.endDate }))
    .sort((a, b) => Number(a.hasEnded) - Number(b.hasEnded) || b.endDate.getTime() - a.endDate.getTime());
}

export function habitTallies(logs: { habitId: string; completed?: boolean }[]): Record<string, number> {
  const tallies: Record<string, number> = {};
  for (const log of logs) {
    if (log.completed) tallies[log.habitId] = (tallies[log.habitId] || 0) + 1;
  }
  return tallies;
}
